export default function ({ next, store, nextMiddleware }) {
  store.getters.isUserLoggedIn
    ? next({ name: "homepage", replace: true })
    : nextMiddleware();
}
